import { render, staticRenderFns } from "./navigation-component.vue?vue&type=template&id=b95209ac"
import script from "./navigation-component.vue?vue&type=script&lang=js"
export * from "./navigation-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports